import { ISilderName, ItemRoutesProps } from "./PageRoute";
import { Route } from "react-router-dom";
import DashboardTemplate from "../../Template/DashboardTemplate";
import GroupDetails from "../../Pages/Master/Group/AllDetailsGroupWise/GroupDetails";
import { SearchLedgerByGroupsTypes } from "../../Services/LedgerService";
import LedgerDetails from "../../Pages/Master/Ledger/LedgerDetails";
import ResourceNotFound from "../ResourceNotFound";
import SalesInvoiceTemplate from "../../Template/SalesInvoiceTemplate";
import MasterNestedRoute from "../../Pages/Master/MasterNestedRoute";
import { findUserPremission } from "../../Pages/Users/Roles/UserSecurityFind";

const MasterRoutes = ({
  currentClient,
  clientSpecificRole,
}: ItemRoutesProps) => {
  return (
    <>
      {/*----------- Master Routes -----------*/}
      <Route
        key="salesInvoice"
        path={`/${currentClient?.id}/master/*`}
        // path={"sales/*"}
        element={
          findUserPremission(
            ["Master.Ledger.View", "Master.Group.View"],
            clientSpecificRole(),
            currentClient?.id!
          ) ? (
            <SalesInvoiceTemplate
              element={<MasterNestedRoute />}
              silderName={ISilderName.Master}
              breadcrumprops={[
                {
                  item: "Master",
                  path: `/billing/clients/${currentClient?.id}/master/group`,
                },
              ]}
              menuprops={[
                {
                  showData: "Ledger",
                  addButton: "addLedger",
                },
                {
                  showData: "Group",
                  addButton: "addGroup",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      {/* Master Inside Details Routes */}
      <Route
        path={`/${currentClient?.id}/master/ledger/:ledgerId`}
        element={
          <DashboardTemplate
            element={
              <LedgerDetails
                searchLedgerByGroupsTypes={
                  SearchLedgerByGroupsTypes.BillingAllGroups
                }
                showName="Ledger"
              />
            }
            breadcrumprops={[
              {
                item: "Master",
                path: `/billing/clients/${currentClient?.id}/master/ledger`,
              },
              {
                item: "Ledger",
                path: `/billing/clients/${currentClient?.id}/master/ledger`,
              },
              {
                item: "Details",
              },
            ]}
          />
        }
      />
      <Route
        path={`/${currentClient?.id}/master/group/:groupId`}
        element={
          <DashboardTemplate
            element={
              <GroupDetails
                searchLedgerByGroupsTypes={SearchLedgerByGroupsTypes.All}
              />
            }
            breadcrumprops={[
              {
                item: "Master",
                path: `/billing/clients/${currentClient?.id}/master/ledger`,
              },
              {
                item: "Group",
                path: `/billing/clients/${currentClient?.id}/master/group`,
              },
              {
                item: "Details",
              },
            ]}
          />
        }
      />
    </>
  );
};

export default MasterRoutes;
